import type { PortfolioFollowupSource } from "@repo/shared/types";

/**
 * QL-309 — display label of a follow-up portfolio's source: the account /
 * savings-agreement name with the bank's identifier in parentheses when it
 * has one ("ASK 1 (12345678901)"). Falls back to whichever part exists.
 */
export function formatFollowupSourceLabel(source: PortfolioFollowupSource): string {
  if (source.name && source.externalId) return `${source.name} (${source.externalId})`;
  return source.name ?? source.externalId ?? source.id;
}
